import { graphqlDynamic } from "react-apollo-dynamic-query"
import { connect } from "react-redux"
import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"
import gql from "graphql-tag"
import moment from "moment"
import ResourceBanner from "."
import {
  getEntityTypeMapping,
  getMatchFromRouter,
} from "../../helpers/sharedHelperFunctions"

const entityQuery = (entityType, bsrCompliance) => `
  entity: ${entityType}(id: $entityId) {
    id
    name
    ${entityType === "user" ? "healthcareRole department { id name }" : ""}
    ${entityType === "location" ? "unit { id name }" : ""}
    compliance: ${
      bsrCompliance ? "bsrCompliance" : "roundingCompliance"
    }(startAt: $startAt, endAt: $endAt) {
      timeslices {
        full {
          aggregates {
            overall {
              compliancePercentage,
              ${
                bsrCompliance
                  ? "compliantOpportunityCount"
                  : "compliantRoundCount"
              },
              ${bsrCompliance ? "opportunityCount" : "roundCount"},
            }
          }
        }
      }
    }
  }
`

const generateQuery = ({ parentEntityType, entityType, bsrCompliance }) => {
  if (parentEntityType) {
    return gql`
      query ResourceBannerNested($parentEntityId: ID!, $entityId: ID!, $startAt: String!, $endAt: String!) {
        parentEntity: ${parentEntityType}(id: $parentEntityId) {
          id
          ${entityQuery(entityType, bsrCompliance)}
        }
      }
    `
  } else {
    return gql`
      query ResourceBanner($entityId: ID!, $startAt: String!, $endAt: String!) {
        ${entityQuery(entityType, bsrCompliance)}
      }
    `
  }
}

const ResourceBannerWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityId, parentEntityId, startAt, endAt, bsrCompliance }) => ({
    variables: {
      entityId,
      parentEntityId,
      startAt: startAt.format(GRAPHQL_DATE_FORMAT),
      endAt: endAt.format(GRAPHQL_DATE_FORMAT),
      bsrCompliance: bsrCompliance,
    },
  }),
  props: ({
    data: { error, loading, entity, parentEntity },
    ownProps: { bsrCompliance },
  }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      entity = entity || (parentEntity && parentEntity.entity)

      if (!entity) {
        throw Error("404")
      }

      const aggs = entity.compliance.timeslices.full.aggregates.overall
      const compliance = aggs.compliancePercentage
      const opportunities = bsrCompliance
        ? aggs.opportunityCount
        : aggs.roundCount

      return {
        entityName: entity.name,
        compliance,
        opportunities,
        detailEntities: [
          entity.healthcareRole,
          entity.department && entity.department.name,
          entity.unit && entity.unit.name,
        ].filter(Boolean), // remove null values
      }
    }
  },
})(ResourceBanner)

const ResourceBannerWithData = connect(
  ({
    router,
    dateRange: { startDate, endDate },
    bsrCompliance: { bsrCompliance },
  }) => {
    const match = getMatchFromRouter(router)

    return {
      startAt: moment(startDate),
      endAt: moment(endDate),
      parentEntityType:
        match.params.parentEntityType &&
        getEntityTypeMapping(match.params.parentEntityType).singularField,
      parentEntityId: match.params.parentEntityId,
      entityType: getEntityTypeMapping(match.params.entityType).singularField,
      entityId: match.params.entityId,
      title:
        !match.params.parentEntityType &&
        match.params.childEntityType &&
        `All ${
          getEntityTypeMapping(match.params.childEntityType).pluralDisplay
        }`, // There will be no parentEntityType on 'index' pages
      bsrCompliance: bsrCompliance,
    }
  }
)(ResourceBannerWithApollo)

export default ResourceBannerWithData
